<div class="seg-header-widget">
  @if (profiles?.length) {
    @for (seg of profiles!; track trackByIndex($index)) {
      <div [style]="styles.section">
        <div [style]="styles.heading">{{ seg.segName }}</div>
        @if (showDescription && seg.segDescription) {
          <p [style]="styles.description">{{ seg.segDescription }}</p>
        }
        <div [style]="styles.defGrid">
          @if (seg.segCode) {
            <span [style]="styles.defItem">
              <span [style]="styles.defLabel">{{ labels.code }}:</span><span>{{ seg.segCode }}</span>
            </span>
          }
          <span [style]="styles.defItem">
            <span [style]="styles.defLabel">{{ labels.workers }}:</span><span>{{ seg.numberOfWorkers }}</span>
          </span>
          @if (showContractors) {
            <span [style]="styles.defItem">
              <span [style]="styles.defLabel">{{ labels.contractors }}:</span><span>{{ seg.numberOfContractors }}</span>
            </span>
          }
          <span [style]="styles.defItem">
            <span [style]="styles.defLabel">{{ labels.shiftType }}:</span><span>{{ seg.shiftType }}</span>
          </span>
          <span [style]="styles.defItem">
            <span [style]="styles.defLabel">{{ labels.shiftLength }}:</span><span>{{ seg.shiftLengthHours }}</span>
          </span>
          <span [style]="styles.defItem">
            <span [style]="styles.defLabel">{{ labels.weeklyHours }}:</span><span>{{ seg.avgWeeklyHours }}</span>
          </span>
        </div>
      </div>
    }
  } @else {
    <p [style]="styles.noData">{{ labels.noData }}</p>
  }
</div>
